import { BoneRegeneration } from "./bone-regeneration";
import { CrownLengthening } from "./crown-lengthening";
import { GingivalGraft } from "./gingival-graft";
import { Gingivectomy } from "./gingivectomy";
import { LaserGingivectomy } from "./laser-gingivectomy";
import { PlasticPerioSurgery } from "./plastic-perio-surgery";
import { PocketReduction } from "./pocket-reduction";
import { ScalingRootPlanning } from "./scaling-root-planning";

export const treatments = [
  BoneRegeneration,
  CrownLengthening,
  GingivalGraft,
  Gingivectomy,
  LaserGingivectomy,
  PlasticPerioSurgery,
  PocketReduction,
  ScalingRootPlanning,
];



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/plan/treatments/perio/index.ts